module.exports = __webpack_public_path__ + "img/37710-004.f26f09b6.jpg";